import React from 'react';
import { Link } from 'react-router-dom';

function CookieBanner({ onAccept }) {
  return (
    <div className="cookie-banner">
      <div className="container">
        <div className="cookie-content">
          <div className="cookie-text">
            <h4>🍪 We Use Cookies</h4>
            <p>
              We use cookies to enhance your experience, analyse site traffic, and for marketing purposes. 
              By clicking "Accept All", you consent to our use of cookies. 
              <Link to="/cookie-policy">Learn more</Link>
            </p>
          </div>
          <div className="cookie-actions">
            <button className="btn btn-secondary" onClick={onAccept}>
              Essential Only
            </button>
            <button className="btn btn-primary" onClick={onAccept}>
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
